import script from "./StudentOnboarding.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentOnboarding.vue?vue&type=script&setup=true&lang=js"

import "./StudentOnboarding.vue?vue&type=style&index=0&id=21d30c0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21d30c0c"]])

export default __exports__